<template>
    <Transition name="toast">
        <div v-if="visible" :class="['toast', type]">{{ message }}</div>
    </Transition>
</template>

<script>
export default {
    name: 'ToastHost',
    data() {
        return {
            visible: false,
            message: '',
            type: 'info',
            timer: null
        };
    },
    computed: {
        toast() {
            return this.$store.state.toast;
        }
    },
    watch: {
        toast(value) {
            if (!value) return;
            this.message = value.message;
            this.type = value.type;
            this.visible = true;
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.visible = false;
            }, 3200);
        }
    },
    unmounted() {
        if (this.timer) clearTimeout(this.timer);
    }
};
</script>
